// NOTE (Quinn, 2026-08-28): campaign links arrive with ?source=<code>; matching
// the welcome copy to the promise that earned the click is the message-match
// lever from the ads GTM plan. Codes are campaign-owned and opaque on purpose;
// unknown or absent codes fall through to the default copy + intro video.
export type CampaignWelcomeContent = {
  headline: string;
  subtitle: string;
  gifSrc: string;
  gifAlt: string;
};

export const CAMPAIGN_WELCOME_CONTENT: Record<string, CampaignWelcomeContent> =
  {
    v1: {
      headline: "Turn your ads into landing pages",
      subtitle:
        "Drop an ad into the chat and the agent builds the matching page: same hook, same offer, ready to publish.",
      gifSrc:
        "https://public.replocdn.com/misc/positioning-test-w1/ad-to-landing-r3.gif",
      gifAlt: "An ad dropped into Replo chat becoming a matching landing page",
    },
    v2: {
      headline: "We'll set up your first AI agent for your store",
      subtitle:
        "Point it at your site and Replo builds your brand kit, then we help you wire up your first workflows.",
      gifSrc:
        "https://public.replocdn.com/misc/positioning-test-w1/agent-setup-r3.gif",
      gifAlt:
        "Replo Brand Studio reading a store's website and building its brand kit",
    },
    v3: {
      headline: "An ecommerce agent purpose-built for your store",
      subtitle:
        "Keep your chatbot for the thinking. Replo builds and ships on your real pages, components, and brand.",
      gifSrc:
        "https://public.replocdn.com/misc/positioning-test-w1/agent-hero-r3.gif",
      gifAlt:
        "One prompt in Replo chat building a launch page on the store's real brand",
    },
    v4: {
      headline: "Find what's hurting conversion",
      subtitle:
        "The agent audits your landing pages, shows you what's leaking, and builds variants to test.",
      gifSrc:
        "https://public.replocdn.com/misc/positioning-test-w1/analytics-report-r3.gif",
      gifAlt:
        "Replo Agent pulling a performance report from the store's connected data",
    },
  };
